import React from 'react';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import { withStyles } from '@material-ui/core/styles';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import theme from 'Theme';
import { monthYear } from 'Consts/DateFormats';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  datePicker: {
    width: '100%',
  },
  monthInput: {
    width: '150px',
    marginLeft: theme.spacing(2),
  },
});

const DateOrMonthPicker = ({
  className, classes, value, onChange, label, disabled, startDate, helperText, title, test, testName,
}) => {
  const momentStartDate = moment(startDate);
  const onMonthChange = (val) => {
    const dateMoment = moment(startDate).add(val, 'months');
    const onChangeValue = dateMoment?.isValid()
      ? dateMoment.toISOString()
      : null;
    return onChange(onChangeValue);
  };

  const finalDate = moment(value);
  const months = finalDate ? finalDate.startOf('month').diff(momentStartDate.startOf('month'), 'months') : undefined;

  return (
    <div className={classNames(className, classes.root)} color={theme.palette.facet.accentBlue20}>
      <DateField
        label={label}
        title={title}
        value={value}
        onChange={onChange}
        openTo={'year'}
        views={['year', 'month']}
        format={monthYear}
        disabled={disabled}
        className={classes.datePicker}
        placeholder={monthYear}
        helperText={helperText}
        minDate={startDate}
        test={test}
        testName={testName}
      />
      <TextField
        className={classes.monthInput}
        onChange={onMonthChange}
        type={'number'}
        value={months}
        disabled={disabled}
        label={'Months'}
        focused={!disabled && value}
        test={`${test}-month-difference-input`}
      />
    </div>
  );
};

DateOrMonthPicker.defaultProps = {
  className: undefined,
  value: undefined,
  label: undefined,
  disabled: false,
  startDate: moment().toISOString(),
  helperText: undefined,
  title: undefined,
  test: undefined,
  testName: undefined,
};

DateOrMonthPicker.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  startDate: PropTypes.string,
  helperText: PropTypes.string,
  title: PropTypes.string,
  test: PropTypes.string,
  testName: PropTypes.string,
};

export default withStyles(styles)(DateOrMonthPicker);
